<template>
  <div class="loading" v-show="isShow.isLDShow">
    <div class="limg">
      <div class="linner">
        <img src="./2.jpg" />
        <img src="./3.jpg" />
        <img src="./4.jpg" />
        <img src="./5.jpg" />
        <img src="./6.jpg" />
        <img src="./7.jpg" />
        <img src="./8.jpg" />
        <img src="./9.jpg" />
        <img src="./10.jpg" />
      </div>
    </div>
    <div class="preImgBox">
      <span v-for="(data,index) in preLoadImg" :key="generateId(index)">
        <img v-bind:id="generateId(index)" src="" style="visibility: hidden; width: 1px; height: 1px; position: absolute;">
      </span>
    </div>
    <div class="logo"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isShow: {
      type: Object
    }
  },
  data () {
    return {
      loadingNum: 0,
      preLoadImg: [
        { src: require('../musicplayer/music.png') },
        { src: require('../page-kv/kv_bg.jpg') },
        { src: require('../page-kv/kv_btn.png') },
        { src: require('../page-kv/kv_fw1.png') },
        { src: require('../page-kv/kv_fw2.png') },
        { src: require('../page-kv/kv_fw3.png') },
        { src: require('../page-kv/kv_fw4.png') },
        { src: require('../page-kv/kv_title.png') },
        { src: require('../page-kv/kv_title1.png') },
        { src: require('../page-kv/kv_title2.png') },

        { src: require('../page-one/2subway1.jpg') },
        { src: require('../page-one/2subway2.jpg') },
        { src: require('../page-one/2subway3.jpg') },
        { src: require('../page-one/2subway4_long.jpg') },
        { src: require('../page-one/2subway4_rec.jpg.png') },
        { src: require('../page-one/3office1.jpg') },
        { src: require('../page-one/3office2.jpg') },
        { src: require('../page-one/3office3.jpg') },
        { src: require('../page-one/3office4-bg.jpg') },
        { src: require('../page-one/3office4-box.png') },
        { src: require('../page-one/3office4-per.png') },
        { src: require('../page-one/4select-m.png') },
        { src: require('../page-one/5running1-a.jpg') },
        { src: require('../page-one/5running1-u.jpg') },
        { src: require('../page-one/5running2.jpg') },
        { src: require('../page-one/5running3-green.png') },
        { src: require('../page-one/5running3-red.png') },
        { src: require('../page-one/5running3.jpg') },
        { src: require('../page-one/5running4.jpg') },
        { src: require('../page-one/6rm-bg.jpg') },
        { src: require('../page-one/6rm-box.png') },
        { src: require('../page-one/6rm1.jpg') },
        { src: require('../page-one/6rm2.jpg') },
        { src: require('../page-one/6rm3_hand.png') },
        { src: require('../page-one/7milk-bg.png') },
        { src: require('../page-one/7milk-box.png') },
        { src: require('../page-one/7milk1.jpg') },
        { src: require('../page-one/7milk2.jpg') },
        { src: require('../page-one/7milk3_hand.png') },
        { src: require('../page-one/7milk3_hm.png') },
        { src: require('../page-one/7milk3_milk.png') },
        { src: require('../page-one/7milk4.jpg') },
        { src: require('../page-one/8market2.jpg') },
        { src: require('../page-one/8market3-a.jpg') },
        { src: require('../page-one/8market3-u.jpg') },
        { src: require('../page-one/8market4-a.jpg') },
        { src: require('../page-one/8market4-u.jpg') },
        { src: require('../page-one/8market5_dog1.png') },
        { src: require('../page-one/8market5_dog2.png') },
        { src: require('../page-one/8market5.jpg') },
        { src: require('../page-one/8tail1.png') },
        { src: require('../page-one/8tail2.png') },
        { src: require('../page-one/9market_f1.jpg') },
        { src: require('../page-one/9market_f2.jpg') },
        { src: require('../page-one/10market1.png') },
        { src: require('../page-one/10market2.png') },
        { src: require('../page-one/10market3.jpg') },
        { src: require('../page-one/box.png') },
        { src: require('../page-one/mask-bottom.png') },
        { src: require('../page-one/mask-top.png') },
        { src: require('../page-one/txt1.png') },
        { src: require('../page-one/txt2.png') },
        { src: require('../page-one/txt3.png') },
        { src: require('../page-one/txt4.png') },
        { src: require('../page-one/txt5.png') },
        { src: require('../page-one/txt6.png') },
        { src: require('../page-one/txt7.png') },

        { src: require('../page-three/1.jpg') },
        { src: require('../page-three/2.jpg') },
        { src: require('../page-three/btn1.png') },
        { src: require('../page-three/btn2.png') },
        { src: require('../page-three/ewm.png') },

        { src: require('../page-two/bg.jpg') },
        { src: require('../page-two/btn.png') },
        { src: require('../page-two/t1.png') },
        { src: require('../page-two/xfbg.png') },
        { src: require('../page-two/z1.png') },
        { src: require('../page-two/z2.png') },
        { src: require('../page-two/z3.png') },
        { src: require('../page-two/z4.png') },

        { src: require('../rotate/phone_horizon.png') },

      ]
    }
  },
  methods: {
    generateId (index) {
      return 'mImg' + index
    },
    go () {
      this.isShow.isLDShow = false
      this.isShow.isKVShow = true
    },
    loadNextImg(imgID, max){
      let allImg = $('.preImgBox img')
      let _this = this
      let imgSrc = this.preLoadImg[imgID]['src']

      allImg.eq(imgID).attr('src', imgSrc)
      allImg.eq(imgID)
        .load(function () {
          _this.loadingNum = parseInt(imgID / max*100)

          let squ=Math.floor(_this.loadingNum/10)
          console.log(_this.loadingNum,squ)
          $('.limg img').eq(squ).show()

            imgID++
            if(imgID >= max){
              console.log('complete')
              _this.loadingNum = 100
                _this.go()
            }else{
              _this.loadNextImg(imgID,max)
            }
        })
    }
  },
  mounted () {
    let that = this
    let allImg = $('.preImgBox img')
    let allImgNum = allImg.length
    let imgID = 0
    setTimeout(() => {
      that.loadNextImg(imgID, allImgNum)
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.loading {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(./bg.jpg);
  background-size: 100% auto;
  background-color: #313558;
  background-repeat: no-repeat;

  .limg{
    position: absolute;
    top: 12.375/2rem /* 198/16 */;
    left: 0;
    width: 100%;
    .linner{
      position: relative;
    }
    img{
      width:100%;
      position: absolute;
      left: 0;
      top:0;
      display: none;
    }
  }

  .logo {
    position: absolute;
    left: 50%;
    bottom: 12vh;
    // transform: translateX(-3.90625rem /* 62.5/16 */);
    // width: 7.8125rem /* 125/16 */;
    // height: .875rem /* 14/16 */;
    // background-image: url(./logo.png);
    background-size: 100% 100%;
  }
}
</style>
